import _ from 'lodash';

function additionCustomizer(objValue?: number, srcValue?: number): number {
  if (objValue && srcValue) {
    return (objValue || 0) + (srcValue || 0);
  }
  return objValue || srcValue || 0;
}
// Takes two objects and sums their values
const sumObjects = (total: any, ...args: any) => {
  const result = { ...total };
  // mergeWith mutates total
  _.mergeWith(result, ...args, additionCustomizer);
  return result;
};
export default sumObjects;
